import React from "react";
import logo from "./logo.svg";
import "./css/kft.css";
import "./App.css";
import SiteHeader from "./comps/siteHeader";
import SiteBody from "./comps/siteBody";
import Intro from "./comps/intro";
import Products from "./comps/products";
import PreOrder from "./comps/preOrder";
import useScreenSize from "./hooks/useScreenSize";
import configService from "./services/configs";

const authKey = "authKey";
const authDuration = 1000 * 60 * 60 * 24; // 24 hours
const password = "HiMetaphor24";

function App() {
	const [isAuthEnabled, setIsAuthEnabled] = React.useState<boolean | null>(
		null
	);
	const [isAuthenticated, setIsAuthenticated] =
		React.useState<boolean>(false);

	const screenSizes = useScreenSize();

	React.useEffect(() => {
		const job = async () => {
			const flag = await configService.isAuthEnabled();
			setIsAuthEnabled(flag);
			if (!flag) setIsAuthenticated(true);
		};
		job();
	}, []);

	React.useEffect(() => {
		if (isAuthenticated || isAuthEnabled === null) return () => {};

		const job = async () => {
			const authTime = window.localStorage.getItem(authKey);

			if (authTime) {
				const diff = Date.now() - parseInt(authTime);
				if (diff < authDuration) {
					setIsAuthenticated(true);
					return;
				}
			}

			const userInput = window.prompt(
				"Enter your password to access the site"
			);

			if (userInput) {
				try {
					await configService.auth(userInput);
					window.localStorage.setItem(authKey, Date.now().toString());
					setIsAuthenticated(true);
					return;
				} catch (error) {}
			}

			window.alert("Incorrect password. Please try again.");
			job();
		};
		job();
	}, [isAuthenticated, isAuthEnabled]);

	if (!isAuthenticated) return <div></div>;
	return (
		<div className={"App " + (screenSizes.isLarge ? "desktop" : "mobile")}>
			{/* header */}
			<SiteHeader></SiteHeader>
			<SiteBody>
				{/* intro */}
				<Intro></Intro>
				<Products></Products>

				{/* Pre Order */}
				<PreOrder></PreOrder>
				<div className="siteFooter">
					ⒸATLUS. ⒸSEGA. All rights reserved. SEGA is registered in
					the U.S. Patent and Trademark Office. ATLUS and the ATLUS
					logo are registered trademarks or trademarks of ATLUS Co.,
					Ltd. or its affiliates. SEGA, the SEGA logo and Metaphor:
					ReFantazio are registered trademarks or trademarks of SEGA
					CORPORATION. All other trademarks, logos and copyrights are
					property of their respective owners.
				</div>
			</SiteBody>
		</div>
	);
}

export default App;
